import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './../../../globals/http';

import * as XLSX from 'xlsx';


@Injectable()
export class RelatoriosService {

  

  constructor(private http: HttpClient, private API: HttpService) { }

  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, RelatoriosService.toExportFileName(excelFileName));
  }

   returnModulos() {
    return this.http.get(this.API.getApi() + '/notasAluno/relatorios/modulos');
  }

  returnTodosAlunos() {
    return this.http.get(this.API.getApi() + '/notasAluno/relatorios/all/alunos');
  }

  returnAlunosByModulo(hash) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/all/alunos/modulo/', hash);
  }

  returnAlunosByCurso(hash) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/all/alunos/curso/', hash);
  }

  returnModulosByHash(data) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/modulos/', data);
  }

  returnCursosByModulo(hash) {
    
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/cursos/', hash);
  }

  returnTurmasByCursos(hash) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/turmas/', hash);
  }

  returnAlunosByTurmas(hash) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/alunos/', hash);
  }

  returnAlunoByTurma(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/aluno/', obj);
  }

   returnNotasAtividadesByAluno(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/atividades/', obj);
  } 

   returnNotasAtividadesByAlunoByModulo(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/atividades/modulo', obj);
  }  

   returnNotasAtividadesByAlunoByCurso(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/atividades/modulo/curso', obj);
  }

   returnRelatorioDetalhado(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/detalhado', obj);
  } 

  //POPULAR EXCEL

  returnExcelAlunos() {
    return this.http.get(this.API.getApi() + '/notasAluno/relatorios/dados/excel/all/alunos');
  }

  returnExcelAlunosByModulo(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/dados/excel/modulo/', obj);
  }

  returnExcelAlunosByCurso(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/dados/excel/curso/', obj);
  }

  returnExcelAlunosByTurma(obj) {
    return this.http.post(this.API.getApi() + '/notasAluno/relatorios/dados/excel/turma/', obj);
  }

  

}







// WEBPACK FOOTER //
// ./src/app/authorization/cursos/relatorios/relatorios.service.ts